// Copyright 2026 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react';
import { ToggleGroup } from './ToggleGroup';

// Multi-select pill group for chart stat/percentile visibility
// ("Stats: Mean P90", "Percentiles: P50 P90 P99"). A ToggleGroup preset:
// options are bare strings and the label is the value. options: string[].
export function StatPills({ options, active, onToggle, className }) {
    return (
        <ToggleGroup
            options={options.map(p => ({ value: p, label: p }))}
            value={new Set(active)}
            onChange={onToggle}
            multiSelect
            variant="fill"
            className={className}
        />
    );
}
